import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiSubscriptionPlans extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}